import { TextareaDesignTokens } from '@primeuix/themes/types/textarea';

export const ezTextareaThemeConfig: TextareaDesignTokens = {
  colorScheme: {
    light: {
      root: {
        focusBorderColor: '#167007',
        disabledBackground: 'rgb(var(--ez-primeng-readonly-bg-color-rgb)/40%)',
        color: 'var(--ez-primary-color)',
        placeholderColor: 'var(--ez-text-hint-color)',
        borderColor: 'var(--ez-border-color)',
        hoverBorderColor: 'var(--ez-success-color)',
      },
    },
  },
};
